// Tamil translations
export const ta: Record<string, string> = {
  'menu.dashboard': 'டாஷ்போர்டு', 'menu.orderNew': 'தயாரிப்பு பதிவு', 'menu.customers': 'வாடிக்கையாளர்கள்', 'menu.products': 'தயாரிப்புகள்', 'menu.users': 'பயனர்கள்', 'menu.settings': 'அமைப்புகள்', 'menu.logout': 'வெளியேறு',
  'dashboard.title': 'டாஷ்போர்டு', 'dashboard.todaySales': 'இன்றைய விற்பனை', 'dashboard.totalOrders': 'மொத்த ஆர்டர்கள்', 'dashboard.newOrder': 'புதிய ஆர்டர்', 'dashboard.newCustomer': 'புதிய வாடிக்கையாளர்',
  'order.title': 'புதிய ஆர்டர்', 'order.customer': 'வாடிக்கையாளர்', 'order.products': 'தயாரிப்புகள்', 'order.quantity': 'அளவு', 'order.price': 'விலை', 'order.total': 'மொத்தம்', 'order.payment': 'பணம்', 'order.cash': 'ரொக்கம்', 'order.card': 'கார்டு',
  'users.title': 'பயனர்கள்', 'users.name': 'பெயர்', 'users.email': 'மின்னஞ்சல்', 'users.role': 'பங்கு', 'users.edit': 'திருத்து', 'users.delete': 'நீக்கு',
  'common.yes': 'ஆம்', 'common.no': 'இல்லை', 'common.cancel': 'ரத்து', 'common.save': 'சேமி', 'common.search': 'தேடு', 'common.loading': 'ஏற்றுகிறது...',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy', 'login.login': 'உள்நுழை', 'login.enterPin': 'பின் உள்ளிடவும்', 'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'பதிவு', 'signup.createAccount': 'கணக்கை உருவாக்கு', 'signup.email': 'மின்னஞ்சல்', 'signup.phone': 'தொலைபேசி',
  'menu.reportsAndAccounting': 'அறிக்கைகள் & கணக்கியல்',
  'menu.systemAndCommunication': 'அமைப்பு & தொடர்பு',
};
